<template>
  <v-container fluid fill-height justify-center>
    <v-col>
      <!-- Campo Applicazione -->
      <v-row no-gutters>
        <v-textarea v-model="campoDatiApplicazione" hide-details filled label="Campo Applicazione" auto-grow rows="4"
          row-height="60" />
      </v-row>

      <!-- Modulo MC e Report Audit -->
      <v-row no-gutters v-if="mostraSezioneGruppo">
        <v-col class="mt-5" cols="6">
          <span class="mt-5 mr-3" hide-details style="font-size: 17px">
            Modulo MC:
          </span>
        </v-col>
        <v-col class="mt-5" cols="6">
          <span class="mt-5 mr-3" hide-details style="font-size: 17px">
            Report Audit:
          </span>
        </v-col>
      </v-row>

      <!-- Terzisti - Rischio - Tipologia -->
      <v-row no-gutters>
        <v-row no-gutters class="mt-3">
          <!-- Terzisti -->
          <v-col class="mt-5" cols="1">
            <span style="font-size: 17px">Terzisti:</span>
          </v-col>
          <v-col cols="2">
            <v-checkbox :disabled="uiState.terzisti === false" :input-value="uiState.terzisti === true"
              @change="aggiornaTerzisti(true)" label="SI" color="primary" hide-details />
            <v-checkbox :disabled="uiState.terzisti === true" :input-value="uiState.terzisti === false"
              @change="aggiornaTerzisti(false)" label="NO" color="primary" hide-details />
          </v-col>

          <!-- Rischio -->
          <v-col class="mt-5" cols="1">
            <span style="font-size: 17px">Rischio:</span>
          </v-col>
          <v-col cols="2">
            <v-checkbox :disabled="uiState.rischio === false" :input-value="uiState.rischio === true"
              @change="aggiornaRischio(true)" label="Alto" color="primary" hide-details />
            <v-checkbox :disabled="uiState.rischio === true" :input-value="uiState.rischio === false"
              @change="aggiornaRischio(false)" label="Basso" color="primary" hide-details />
          </v-col>

          <!-- Tipologia -->
          <v-col class="mt-5" cols="1">
            <span style="font-size: 17px">Tipologia:</span>
          </v-col>
          <v-col cols="1">
            <v-checkbox v-model="uiState.tipologia.verniciatore" label="Verniciatore" color="primary" hide-details
              @change="notificaUpdate" />
            <v-checkbox v-model="uiState.tipologia.commercialista" label="Commercialista" color="primary" hide-details
              @change="notificaUpdate" />
            <v-checkbox v-model="uiState.tipologia.lamellatore" label="Lamellatore" color="primary" hide-details
              @change="notificaUpdate" />
          </v-col>

          <!-- Date Ingresso e Rimozione -->
          <v-col cols="4">
            <v-row no-gutters>
              <v-spacer />
              <campo-data v-model="campoDatiDataIngresso" label="Data Ingresso" class-custom="ml-10 mt-4"
                style="max-width: 160px" />
              <campo-data v-model="campoDatiDataRimozione" label="Data Rimozione" class-custom="ml-10 mt-4"
                style="max-width: 160px" />
            </v-row>
          </v-col>
        </v-row>
      </v-row>

      <!-- Opzioni specifiche (Legno controllato, etc.) -->
      <v-row no-gutters>
        <v-col cols="3">
          <v-radio-group v-model="campoDatiLegnoControllato">
            <template v-slot:label>
              <div>Legno controllato</div>
            </template>
            <v-radio label="SI" :value="true" />
            <v-radio label="NO" :value="false" />
          </v-radio-group>
        </v-col>
        <v-col cols="3">
          <v-radio-group v-model="campoDatiMaterialeRiciclato">
            <template v-slot:label>
              <div>Materiale riciclato</div>
            </template>
            <v-radio label="SI" :value="true" />
            <v-radio label="NO" :value="false" />
          </v-radio-group>
        </v-col>
        <v-col cols="3">
          <v-radio-group v-model="campoDatiLogoSuProdotto">
            <template v-slot:label>
              <div>Uso del logo sul prodotto</div>
            </template>
            <v-radio label="SI" :value="true" />
            <v-radio label="NO" :value="false" />
          </v-radio-group>
        </v-col>
        <v-col cols="3">
          <v-radio-group v-model="campoDatiLogoPromozionale">
            <template v-slot:label>
              <div>Uso del logo promozionale</div>
            </template>
            <v-radio label="SI" :value="true" />
            <v-radio label="NO" :value="false" />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import CampoData from "./CampoData.vue";

export default {
  name: "DatiGruppo",

  components: {
    CampoData,
  },

  props: {
    cliente: {
      type: Object,
      required: true,
    },
    uiState: {
      type: Object,
      required: true,
    },
    tipoCertificazione: {
      type: String,
      required: true,
      validator: (value) => ["FSC", "PEFC"].includes(value),
    },
  },

  computed: {
    mostraSezioneGruppo() {
      if (this.tipoCertificazione === "FSC") {
        return this.cliente.certificazioneFSCG;
      }
      return this.cliente.certificazionePEFCG;
    },

    // Computed properties per mappare i campi del cliente in base al tipo
    campoDatiApplicazione: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.applicazione
          : this.cliente.applicazionePEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.applicazione = value;
        } else {
          this.cliente.applicazionePEFC = value;
        }
      },
    },

    campoDatiDataIngresso: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.dataIngresso
          : this.cliente.dataIngressoPEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.dataIngresso = value;
        } else {
          this.cliente.dataIngressoPEFC = value;
        }
      },
    },

    campoDatiDataRimozione: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.dataRimozione
          : this.cliente.dataRimozionePEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.dataRimozione = value;
        } else {
          this.cliente.dataRimozionePEFC = value;
        }
      },
    },

    campoDatiLegnoControllato: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.legnoControllato
          : this.cliente.legnoControllatoPEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.legnoControllato = value;
        } else {
          this.cliente.legnoControllatoPEFC = value;
        }
      },
    },

    campoDatiMaterialeRiciclato: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.materialeRiciclato
          : this.cliente.materialeRiciclatoPEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.materialeRiciclato = value;
        } else {
          this.cliente.materialeRiciclatoPEFC = value;
        }
      },
    },

    campoDatiLogoSuProdotto: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.logoSuProdotto
          : this.cliente.logoSuProdottoPEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.logoSuProdotto = value;
        } else {
          this.cliente.logoSuProdottoPEFC = value;
        }
      },
    },

    campoDatiLogoPromozionale: {
      get() {
        return this.tipoCertificazione === "FSC"
          ? this.cliente.logoPromozionale
          : this.cliente.logoPromozionalePEFC;
      },
      set(value) {
        if (this.tipoCertificazione === "FSC") {
          this.cliente.logoPromozionale = value;
        } else {
          this.cliente.logoPromozionalePEFC = value;
        }
      },
    },
  },

  methods: {
    aggiornaTerzisti(valore) {
      const nuovoState = { ...this.uiState, terzisti: valore };
      this.$emit("update:ui-state", nuovoState);
    },

    aggiornaRischio(valore) {
      const nuovoState = { ...this.uiState, rischio: valore };
      this.$emit("update:ui-state", nuovoState);
    },

    notificaUpdate() {
      this.$emit("update:ui-state", { ...this.uiState });
    },
  },
};
</script>
